import { format } from "date-fns";

export const lastCreatedAt = (items) => {
    const lastCreatedAt = items[0]?.createdAt;
    const lastCreatedAtDate = new Date(lastCreatedAt);
    if(lastCreatedAtDate == "Invalid Date") return "";
    return format(lastCreatedAtDate, "dd/MM/yyyy HH:mm");
}